import React from 'react'

import QuestionsScreen from './questionsScreen.js'
import PersonScreen from './personScreen.js'

export default class SplitScreen extends React.Component{

	constructor(props) {
		super(props)
		this.state = {
			age: undefined,
			name: undefined,
		}
	}

	setPersonProperties = (state, value) => {
		this.setState({
			[state]: value,
		})
	}

	render(){
		const {
			data, 
			handler,
			gender,
			nationality,
			profession,
			religion,
			relationshipID,
			hobbyID,
			petID,
			setProperties,
			lang,
			gender_id
		} = this.props
		const {
			age,
			name,
		} = this.state

		return(
			<div className='splitscreen'>
					<PersonScreen
						data={data}
						gender={gender}
						nationality={nationality}
						profession={profession}
						religion={religion}
						relationship={relationshipID}
						hobby={hobbyID}
						pet={petID}
						selectedAge={age}
						name={name}
						age={age}
						lang={lang}
						gender_id={gender_id}
					/>
				<QuestionsScreen
					data={data}
					handler={handler}
					setPersonProperties={this.setPersonProperties}
					setProperties={setProperties}
					lang={lang}
					name={name}
				/>
			</div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/components/splitScreen/splitScreen.js